// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__T7vVI","label":"SetPasswdForm_label__3-tEv"};